import { TextV2 as Text } from '@pinchenterprisesnpm/friday-ui'
import { SectionItem } from '@features/shift-post-v2/components'
import {
  ACCEPTANCE_CRITERIA_OPTION,
  ShiftPostStep,
} from '@features/shift-post-v2/steps'
import { useModal } from '@src/hooks/useModal'
import { InvitationSummaryModal } from '@src/features/shift-post-v2/steps/invite-upshifters-step/components/invite-upshifters-section/modals/invitation-summary-modal'
import { InviteUpshiftersContent } from '@src/features/shift-post-v2/steps/invite-upshifters-step/components/invite-upshifters-section/components/invite-upshifters-content/invite-upshifters-content'
import { ConfirmSummary } from '@src/features/shift-post-v2/steps/invite-upshifters-step/components/invite-upshifters-section/components/confirm-summary/confirm-summary'
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons'
import { InfoBanner } from '@src/features/shift-post-v2/components/info-banner/info-banner'
import { useMemo } from 'react'
import { getSelectedAcceptanceCriteriaOption } from '@src/features/shift-post-v2/utils'
import { connect } from 'formik'
import { IInviteUpshiftersSectionProps } from './invite-upshifters-section.types'

export const REORDERING_AVAILABLE = true

export const InviteUpshiftersSection = connect<IInviteUpshiftersSectionProps>(
  ({ sourceStep, formik }) => {
    const { values } = formik
    const [isOpen, toggleModal, closeModal] = useModal()
    const isConfirmStep = sourceStep === ShiftPostStep.CONFIRM

    const selectedAcceptanceCriteriaOption = useMemo(() => {
      return getSelectedAcceptanceCriteriaOption(
        values.auto_accept_by_rosters,
        values.auto_accept,
      )
    }, [values.auto_accept_by_rosters, values.auto_accept])

    return (
      <SectionItem
        title={
          isConfirmStep
            ? 'Invitation summary'
            : 'Would you like to invite Upshifters from your rosters first?'
        }
        isOptional={!isConfirmStep}
        hasEdit={isConfirmStep}
        onEdit={toggleModal}
      >
        {selectedAcceptanceCriteriaOption ===
          ACCEPTANCE_CRITERIA_OPTION.VERIFIED_FROM_ROSTERS && (
          <InfoBanner
            description="Rosters that are selected in the acceptance criteria step will be invited automatically."
            icon={faInfoCircle}
          />
        )}
        {!isConfirmStep && (
          <>
            <Text mt={10} mb={10}>
              Send personalised invites exclusively to Upshifters you`ve
              previously worked with. They`ll have priority access for the next
              12 hours.
            </Text>
            <InviteUpshiftersContent />
          </>
        )}
        {isConfirmStep && (
          <>
            <ConfirmSummary />
            <InvitationSummaryModal isOpen={isOpen} closeModal={closeModal} />
          </>
        )}
      </SectionItem>
    )
  },
)
